import { render, staticRenderFns } from "./IframeAdminBar.vue?vue&type=template&id=0f18e858&"
import script from "./IframeAdminBar.vue?vue&type=script&lang=js&"
export * from "./IframeAdminBar.vue?vue&type=script&lang=js&"
import style0 from "./IframeAdminBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports